export const createQuestionObject = ({
  id,
  content,
  type,
  dataSetId,
  surveyId,
  surveyVersionId,
  surveyDeploymentId,
  template,
  required,
  choicesOrder,
  regionalBreakdown,
  organizationId,
}) => {
  const assignedDeploymentId = surveyDeploymentId ?? null;

  const question = {
    id,
    question: {
      id,
      type,
      content,
      surveyId,
      template,
      required,
      dataSetId,
      choicesOrder,
      organizationId,
      surveyVersionId,
      regionalBreakdown,
      surveyDeploymentId: assignedDeploymentId,
    },
  };

  return question;
};
